import React, {useContext} from 'react';
import {CitizenContext} from "../context/citizen-context.jsx";
import CitizenGeneralAddress from "./citizen-general-address.jsx";

const CitizenAddress = () => {
    const {citizen, setCitizen} = useContext(CitizenContext);

    const handleArrayItems = (value, target) => setCitizen(prev => ({...prev, [target]: value}));

    return (
        <>
            <CitizenGeneralAddress
                title={"Endereços"}
                addresses={citizen.addresses}
                onChange={(value) => handleArrayItems(value, "addresses")}
                height={"h-[calc(100vh-200px)]"}
                isCitizen={true}
            />
        </>
    );
};

export default CitizenAddress;